// CheckoutForm.js
import React from 'react';
import {injectStripe,CardElement} from 'react-stripe-elements';
import {
    Grid,
    Row,
    Col
  } from "react-bootstrap";  
import CardSection from './CardSection';
import ProgressButton from "components/ProgressButton/ProgressButton.jsx";
import { WEB_URL } from "variables/Variables.jsx";
import Iframe from "components/Iframe.jsx"

var Paddle = window.Paddle || {};

class CheckoutForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
        runningStripePurchase : false,
        clientSecret : null,
        purchaseDisabled : true,
        cardElement : null,
        cardErrorMessage : '',
        paymentStatusText : 'Preparing payment form. Please wait..'
    }
  }

  handleSubmit = async (ev) => {
    // We don't want to let default form submission happen here, which would refresh the page.
    ev.preventDefault();


    if(!this.props.createSubscription){
        // this.props.stripe.createToken({type: 'card', name: 'Jenny Rosen'});
        this.props.stripe.createToken() 
        .then(payload => this.processStripePayment(payload)); 
    }else{
        // this.props.stripe.createToken({type: 'card', name: 'Jenny Rosen'});
        this.props.stripe.createToken() 
        .then(payload => this.processStripeSubscription(payload)); 
    }
  };

  componentDidMount() {
    if(!this.props.usePaddle){
        if(!this.props.createSubscription){
            fetch("https://"+WEB_URL+"/account/api/renew-flowpaper-services",{
                'method' : 'POST',
                'headers' : { 'Content-Type' : 'application/json'},
                //'body' : 'action=intent&amount='+Number(this.props.transactionAmount)+'&token='+this.props.authDetail.token+'&checksum='+this.props.authDetail.checksum+'&email='+this.props.authDetail.detail.email
                'body' : JSON.stringify({'action':'intent','amount':+Number(this.props.transactionAmount),'token':this.props.authDetail.token,'checksum':this.props.authDetail.checksum,'email':this.props.authDetail.detail.email})
            }).then(res => res.json())
            .then(
            (response) => {
                if(response.result == 'SUCCESS'){
                    this.setState({clientSecret : response.intent, purchaseDisabled: false});
                }else{
                    if(response.message == 'Please check your Tax ID'){
                        this.props.triggerNotification('error','tc','Incorrect Tax/VAT ID. Please update your VAT ID and try again.');    
                    }else{
                        this.props.triggerNotification('error','tc','Payment system currently unavailable. Please contact support for assistance.');    
                    }
                }
            },
            (error) => {
                this.props.triggerNotification('error','tc','Error processing the transaction. Please check your card details.');
                this.setState({runningStripePurchase : false});
            }
            )
        }else{
            fetch("https://"+WEB_URL+"/account/api/creative-services",{
                'method' : 'POST',
                'headers' : { 'Content-Type' : 'application/json'},
                'body' : JSON.stringify({'action':'intent','amount':Number(this.props.transactionAmount),'token':this.props.authDetail.token,'checksum':this.props.authDetail.checksum,'email':this.props.authDetail.detail.email})
                //'body' : 'action=intent&amount='+Number(this.props.transactionAmount)+'&token='+this.props.authDetail.token+'&checksum='+this.props.authDetail.checksum+'&email='+this.props.authDetail.detail.email
            }).then(res => res.json())
            .then(
            (response) => {
                if(response.result == 'SUCCESS'){
                    this.setState({clientSecret : response.intent, purchaseDisabled: false});
                }else{
                    if(response.message == 'Please check your Tax ID'){
                        this.props.triggerNotification('error','tc','Incorrect Tax/VAT ID. Please update your VAT ID and try again.');    
                    }else{
                        this.props.triggerNotification('error','tc','Payment system currently unavailable. Please contact support for assistance.');    
                    }
                }
            },
            (error) => {
                this.props.triggerNotification('error','tc','Error processing the transaction. Please check your card details.');
                this.setState({runningStripePurchase : false});
            }
            )
        }
    }

    if(this.props.usePaddle){
        // 1. Check if we need more details from the user. If we do then we'll show these fields first
        // 2. Let the user proceed to the paddle payment form

        this.showPaddle();
    }
  };

  async showPaddle(){
    var _this = this;

    var countryCodes = {
        "Afghanistan": "AF",
        "Albania": "AL",
        "Algeria": "DZ",
        "American Samoa": "AS",
        "Andorra": "AD",
        "Angola": "AO",
        "Anguilla": "AI",
        "Antarctica": "AQ",
        "Antigua and Barbuda": "AG",
        "Argentina": "AR",
        "Armenia": "AM",
        "Aruba": "AW",
        "Australia": "AU",
        "Austria": "AT",
        "Azerbaijan": "AZ",
        "Bahamas": "BS",
        "Bahrain": "BH",
        "Bangladesh": "BD",
        "Barbados": "BB",
        "Belarus": "BY",
        "Belgium": "BE",
        "Belize": "BZ",
        "Benin": "BJ",
        "Bermuda": "BM",
        "Bhutan": "BT",
        "Bolivia": "BO",
        "Bosnia and Herzegovina": "BA",
        "Botswana": "BW",
        "Bouvet Island": "BV",
        "Brazil": "BR",
        "British Indian Ocean Territory": "IO",
        "Brunei Darussalam": "BN",
        "Bulgaria": "BG",
        "Burkina Faso": "BF",
        "Burundi": "BI",
        "Cambodia": "KH",
        "Cameroon": "CM",
        "Canada": "CA",
        "Cape Verde": "CV",
        "Cayman Islands": "KY",
        "Central African Republic": "CF",
        "Chad": "TD",
        "Chile": "CL",
        "China": "CN",
        "Christmas Island": "CX",
        "Cocos (Keeling) Islands": "CC",
        "Colombia": "CO",
        "Comoros": "KM",
        "Congo": "CG",
        "Congo, the Democratic Republic of the": "CD",
        "Cook Islands": "CK",
        "Costa Rica": "CR",
        "Cote d'Ivoire": "CI",
        "Croatia": "HR",
        "Cuba": "CU",
        "Cyprus": "CY",
        "Czech Republic": "CZ",
        "Denmark": "DK",
        "Djibouti": "DJ",
        "Dominica": "DM",
        "Dominican Republic": "DO",
        "East Timor": "TL",
        "Ecuador": "EC",
        "Egypt": "EG",
        "El Salvador": "SV",
        "Equatorial Guinea": "GQ",
        "Eritrea": "ER",
        "Estonia": "EE",
        "Ethiopia": "ET",
        "Falkland Islands": "FK",
        "Faroe Islands": "FO",
        "Fiji": "FJ",
        "Finland": "FI",
        "France": "FR",
        "Gabon": "GA",
        "Gambia": "GM",
        "Georgia": "GE",
        "Germany": "DE",
        "Ghana": "GH",
        "Gibraltar": "GI",
        "Greece": "GR",
        "Greenland": "GL",
        "Grenada": "GD",
        "Guadeloupe": "GP",
        "Guam": "GU",
        "Guatemala": "GT",
        "Guinea": "GN",
        "Guinea-Bissau": "GW",
        "Guyana": "GY",
        "Haiti": "HT",
        "Honduras": "HN",
        "Hong Kong": "HK",
        "Hungary": "HU",
        "Iceland": "IS",
        "India": "IN",
        "Indonesia": "ID",
        "Iran": "IR",
        "Iraq": "IQ",
        "Ireland": "IE",
        "Israel": "IL",
        "Italy": "IT",
        "Jamaica": "JM",
        "Japan": "JP",
        "Jordan": "JO",
        "Kazakhstan": "KZ",
        "Kenya": "KE",
        "Kiribati": "KI",
        "Kuwait": "KW",
        "Kyrgyzstan": "KG",
        "Lao People's Democratic Republic": "LA",
        "Latvia": "LV",
        "Lebanon": "LB",
        "Lesotho": "LS",
        "Liberia": "LR",
        "Libya": "LY",
        "Liechtenstein": "LI",
        "Lithuania": "LT",
        "Luxembourg": "LU",
        "Macau": "MO",
        "Madagascar": "MG",
        "Malawi": "MW",
        "Malaysia": "MY",
        "Maldives": "MV",
        "Mali": "ML",
        "Malta": "MT",
        "Marshall Islands": "MH",
        "Martinique": "MQ",
        "Mauritania": "MR",
        "Mauritius": "MU",
        "Mexico": "MX",
        "Micronesia": "FM",
        "Moldova": "MD",
        "Monaco": "MC",
        "Mongolia": "MN",
        "Montserrat": "MS",
        "Morocco": "MA",
        "Mozambique": "MZ",
        "Myanmar": "MM",
        "Namibia": "NA",
        "Nauru": "NR",
        "Nepal": "NP",
        "Netherlands": "NL",
        "New Zealand": "NZ",
        "Nicaragua": "NI",
        "Niger": "NE",
        "Nigeria": "NG",
        "Norway": "NO",
        "Oman": "OM",
        "Pakistan": "PK",
        "Panama": "PA",
        "Peru": "PE",
        "Philippines": "PH",
        "Poland": "PL",
        "Portugal": "PT",
        "Qatar": "QA",
        "Romania": "RO",
        "Russia": "RU",
        "Saudi Arabia": "SA",
        "South Africa": "ZA",
        "Spain": "ES",
        "Sri Lanka": "LK",
        "Sweden": "SE",
        "Switzerland": "CH",
        "Turkey": "TR",
        "United Kingdom": "GB",
        "United States": "US"
    };

    var paddleCustomerObject = { 
        email: _this.props.authDetail.detail.email,
        address: {
            countryCode: _this.props.authDetail.detail.BillingCountry?countryCodes[_this.props.authDetail.detail.BillingCountry]:_this.props.authDetail.detail.CountryCode,
            postalCode: _this.props.authDetail.detail.BillingZip,
            city: _this.props.authDetail.detail.BillingCity,
            firstLine: _this.props.authDetail.detail.BillingAddress,
        }
    };

    if(_this.props.authDetail.detail.TaxID){
        var custName = _this.props.authDetail.detail.name?_this.props.authDetail.detail.name:_this.props.authDetail.detail.BillingName;
        paddleCustomerObject.business = {
            name: (custName?custName:_this.props.authDetail.detail.email),
            taxIdentifier: _this.props.authDetail.detail.TaxID
        }    
    }

    try{
        var priceId = '';
        if(_this.props.product == 'domain'){
            priceId = window.PADDLE_CONFIG.prices.AdditionalDomain;
        }
        if(_this.props.product == 'createsubscription'){
            priceId = window.PADDLE_CONFIG.prices.Creative['annually'];

            if(_this.props.authDetail.item && _this.props.authDetail.item.indexOf('Team')>-1){
                priceId = window.PADDLE_CONFIG.prices.Team['annually'];    
            }
        }
        if(_this.props.product == 'services'){
            priceId = window.PADDLE_CONFIG.prices.Services;
        }

        if(_this.props.transactionId){
            Paddle.Checkout.open({
                transactionId : _this.props.transactionId,
                customer: paddleCustomerObject,
                settings: {
                    displayMode: "inline",
                    frameTarget: "paddle-target-container",
                    frameInitialHeight: "450",
                    frameStyle: "width: 100%; min-width: 312px; background-color: transparent; border: none;",
                    theme: "light",
                    allowLogout: false,
                    showAddTaxId: true,
                    successUrl: "https://flowpaper.com/account/?viaPaddle=true"
                }
            });
        }else{
            Paddle.Checkout.open({
                items: [
                    {
                    priceId: priceId,
                    quantity: 1
                    }
                ],
                customer: paddleCustomerObject,
                settings: {
                    displayMode: "inline",
                    frameTarget: "paddle-target-container",
                    frameInitialHeight: "450",
                    frameStyle: "width: 100%; min-width: 312px; background-color: transparent; border: none;",
                    theme: "light",
                    allowLogout: false,
                    showAddTaxId: true,
                    successUrl: "https://flowpaper.com/account/?viaPaddle=true"
                }
            });
        }
    } catch (error) {
        console.error(`Checkout error: ${error.message}`);
    } 
  }

  async processStripeSubscription(stripeResponse){
    var _this = this;

    var tokenResult = await _this.props.stripe.createToken();
    
    if(!tokenResult.error){
        _this.setState({runningStripePurchase : true, paymentStatusText : 'Processing payment..'});

        const setupIntentResult = await _this.props.stripe.confirmCardSetup(_this.state.clientSecret,
            {
            payment_method: {
                card: _this.state.cardElement
            }
            }
        );

        if(setupIntentResult && setupIntentResult.setupIntent && setupIntentResult.setupIntent.status == 'succeeded'){
            // proceed with creating the subscription using setupIntentResult.setupIntent.payment_method
            
            fetch("https://"+WEB_URL+"/account/api/creative-services",{
                'method' : 'POST',
                'headers' : { 'Content-Type' : 'application/json'},
                //'body' : 'action=createsubscription&product='+_this.props.product+'&paymentMethod='+setupIntentResult.setupIntent.payment_method+'&amount='+Number(_this.props.transactionAmount)+'&token='+_this.props.authDetail.token+'&checksum='+_this.props.authDetail.checksum+'&email='+_this.props.authDetail.detail.email+'&txn_id='+_this.props.authDetail.txn_id
                'body' : JSON.stringify({'action':'createsubscription','product':_this.props.product,'paymentMethod':setupIntentResult.setupIntent.payment_method,'amount':Number(_this.props.transactionAmount),'token':_this.props.authDetail.token,'checksum':_this.props.authDetail.checksum,'email':_this.props.authDetail.detail.email,'txn_id':_this.props.authDetail.txn_id})
                }).then(res => res.json())
                .then(
                    (response) => {
                        if(response.result == 'SUCCESS' && response.txn_id){
                            // triggering log in again so we get a new cookie
                            fetch("https://"+WEB_URL+"/account/api/login",{
                                'method' : 'POST',
                                'headers' : { 'Content-Type' : 'application/json'},
                                'body' : JSON.stringify({'token':_this.props.authDetail.token,'email':_this.props.authDetail.checksum,'detail':true}),
                                'credentials': 'same-origin'
                                }).then(res => res.json())
                                .then(
                                    (result) => {
                                        if(result.auth == 'AUTH_OK'){
                                            _this.props.setLoggedIn(result,_this.props.authEmail,true);
                                            }else{
                                            _this.props.setLoggedIn(false);    
                                            }
                                    },
                                    (error) => {
                                        _this.props.setLoggedIn(false);
                                    }
                                    )

                            this.props.triggerNotification('success','tc','Transaction processed successfully. Your account has been upgraded.');
                            this.props.onHide();
                        }else if(response.result == 'SUCCESS' && !response.txn_id){
                            this.props.triggerNotification('success','tc','Transaction processed successfully but you need to confirm your payment using additional security instructions. Please see your email inbox for further details.');
                            this.props.onHide();
                        }else{
                            if(response.message == 'Please check your Tax ID'){
                                this.props.triggerNotification('error','tc','Incorrect Tax/VAT ID. Please update your VAT ID and try again.');    
                            }else{
                                this.props.triggerNotification('error','tc','Error processing the transaction. Please check your card details and try again.');
                            }

                            this.props.onHide();
                        }
            
                        this.setState({runningStripePurchase : false});
                    },
                    (error) => {
                        debugger;
                        this.props.triggerNotification('error','tc','Error processing the transaction. Please check your card details and try again.');
                        this.setState({runningStripePurchase : false});
                        this.props.onHide();
                    }
                )
            
        }else{
            this.props.triggerNotification('error','tc','Error processing the transaction. Please check your card details and try again.');
            this.props.onHide();
        }
    }
  }

  async processStripePayment(stripeResponse){
    var _this = this;

    var tokenResult = await _this.props.stripe.createToken();
    
    if(!tokenResult.error){
        _this.setState({runningStripePurchase : true, paymentStatusText : 'Processing payment..'});

        const { paymentIntent, error } = await _this.props.stripe.handleCardPayment(
            _this.state.clientSecret,
            _this.state.cardElement,
        );
    
        if(paymentIntent && paymentIntent.status == 'succeeded'){
            fetch("https://"+WEB_URL+"/account/api/renew-flowpaper-services",{
                'method' : 'POST',
                'headers' : { 'Content-Type' : 'application/json'},
                'body' : JSON.stringify({'action':'checkintent','product':_this.props.product,'token':_this.props.authDetail.token,'checksum':_this.props.authDetail.checksum,'paymentIntentId':paymentIntent.id,'email':_this.props.authDetail.detail.email,'txn_id':_this.props.authDetail.txn_id})
                //'body' : 'action=checkintent&product='+_this.props.product+'&token='+_this.props.authDetail.token+'&checksum='+_this.props.authDetail.checksum+'&paymentIntentId='+paymentIntent.id+'&email='+_this.props.authDetail.detail.email+'&txn_id='+_this.props.authDetail.txn_id
                }).then(res => res.json())
                .then(
                    (response) => {
                        if(response.result == 'SUCCESS'){
                            // triggering log in again so we get a new cookie
                            fetch("https://"+WEB_URL+"/account/api/login",{
                                'method' : 'POST',
                                'headers' : { 'Content-Type' : 'application/json'},
                                'body' : JSON.stringify({'token':_this.props.authDetail.token,'email':_this.props.authDetail.checksum,'detail':true}),
                                'credentials': 'same-origin'
                                }).then(res => res.json())
                                .then(
                                    (result) => {
                                        if(result.auth == 'AUTH_OK'){
                                            _this.props.setLoggedIn(result,_this.props.authEmail,true);
                                            }else{
                                            _this.props.setLoggedIn(false);    
                                            }
                                    },
                                    (error) => {
                                        _this.props.setLoggedIn(false);
                                    }
                                )
    
                            if(_this.props.product == 'services'){
                                this.props.triggerNotification('success','tc','Transaction processed successfully. Your account has been renewed.');
                            }

                            if(_this.props.product == 'domain'){
                                this.props.triggerNotification('success','tc','Transaction processed successfully. An additional domain has been added to your account.');
                            }

                            this.props.onHide();
                        }else{

                            if(response.message == 'Please check your Tax ID'){
                                this.props.triggerNotification('error','tc','Incorrect Tax/VAT ID. Please update your VAT ID and try again.');    
                            }else{
                                this.props.triggerNotification('error','tc','Error processing the transaction. Please check your card details and try again.');
                            }

                            this.props.onHide();
                        }
            
                        this.setState({runningStripePurchase : false});
                    },
                    (error) => {
                        this.props.triggerNotification('error','tc','Error processing the transaction. Please check your card details and try again.');
                        this.setState({runningStripePurchase : false});
                        this.props.onHide();
                    }
                )
        }else{
            this.props.triggerNotification('error','tc','Error processing the transaction. Please check your card details and try again.');
            this.setState({runningStripePurchase : false});
            this.props.onHide();
        }            
    }
  }

  handleCardReady = element => {
    this.setState({ cardElement: element });
  };
  

  handleCardChange = ({error}) => {
    if (error) {
      this.setState({cardErrorMessage: error.message});
    }
  };

  render() {
    var _this = this;
    return (
    <div className={!this.props.usePaddle?'card':''} style={{backgroundColor:((!this.props.usePaddle)?'#f5f5f7':'#ffffff'),paddingTop:15}}>
        <Grid fluid>
        {(!this.props.usePaddle)?
        <form onSubmit={this.handleSubmit}>
            <Row className="show-grid">
                <Col xs={12} md={8}>
                <label>
                    Card details
                    <CardElement onChange={this.handleCardChange} disabled={this.state.purchaseDisabled} onReady={this.handleCardReady} style={{base: {fontSize: '14px'}}} hidePostalCode={true} />
                    <div className="error" role="alert">
                        {this.state.errorMessage}
                    </div>
                </label>
                </Col>
            </Row>
            <Row className="show-grid">
                <Col xs={12} md={8}>
                <ProgressButton waitingText={this.state.paymentStatusText} disabled={this.state.purchaseDisabled} runningAsyncOperation={this.state.purchaseDisabled || this.state.runningStripePurchase} bsStyle="info" fill type="submit">
                    <i className="fa fa-credit-card" style={{paddingRight:25}}></i>Charge my card ${Number(this.props.transactionAmount).toFixed(2)} now
                </ProgressButton>                    
                </Col>
            </Row>
        </form>
        :
        <form onSubmit={this.handleSubmit}>
            <Row className="show-grid">
                {this.props.transactionId==null?
                <Col xs={12} md={3}>
                <div style={{marginBottom: "-5px",height:"85px",marginTop:"10px"}}>
                    <div id="paddleTaxDetailBox" style={{display:"block"}}>
                        <h1 className="paddlePrice" id="txtPaddlePrice">${this.props.transactionAmount.toFixed(2)} </h1>
                        <span className="paddleTax" id="txtPaddleTax">+ TAX IF ANY</span>
                        <span className="paddleDescr"><b>Make sure to add your VAT/Tax ID to avoid unnessecary tax charges.</b></span>
                    </div>
                </div>
                </Col>:<Col xs={12} md={3}>
                <span className="paddleDescr">This will just update your payment details. There is no fee charged.</span><br/>
                <span className="paddleDescr"><b>Make sure to supply your VAT/Tax ID to avoid unnessecary tax charges to future invoices.</b></span>
                </Col>}
                <Col xs={12} md={9} style={{backgroundColor:'#f5f5f7',minHeight:'485px'}}>
                    <div className="paddle-target-container">
                        
                    </div>
                </Col>
            </Row>
        </form>
        }
      </Grid>
      </div>
    );
  }
}

export default injectStripe(CheckoutForm);